import Entity from '../entity'
export default class ISOCode extends Entity<number> {
    code: string;
    description: string;
    length: number;
    width: number;
    height: number;
    containerSizeId: number;
    containerTypeId: number;
}